<template>
    <div class="w-full">
        <div class="line-area-chart overflow-hidden items-no-padding">
            <vue-apex-charts ref="apex" type="area" height="350" :options="chartArea.chartOptions" :series="chartArea.series"></vue-apex-charts>
        </div>
    </div>
</template>

<script>
    import VueApexCharts from 'vue-apexcharts'
    import { currentApexLocale } from '@/components/statistics-cards/apexChartConfig.js'
    import { mapGetters } from 'vuex'

    const themeColors = ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#03befc']

    export default {
        components : {
            VueApexCharts
        },

        data () {
            return {
            }
        },

        computed : {
            chartArea () {
                let series = []
                let categories = []
                this.statisticsRatings.forEach(rating => {
                    // CATEGORIES
                    categories.push(rating.date)

                    // SERIES
                    rating.ratings.forEach(total => {
                        const foundSerie = series.find(serie => serie.star == total.star)
                        if(foundSerie)
                            foundSerie.data.push(total.total)
                        else {
                            series.push({
                                star : total.star,
                                name: `${total.star} estrela(s)`,
                                data : [total.total]
                            })
                        }
                    })
                })

                return {
                    series: series,
                    chartOptions: {
                        chart: {
                            defaultLocale: this.$i18n.locale,
                            locales : currentApexLocale,
                            type: 'area',
                            dropShadow: {
                                enabled: true,
                                top: 5,
                                left: 0,
                                blur: 4,
                                opacity: 0.10,
                            },
                            toolbar: {
                                show: true,
                            },
                            sparkline: {
                                enabled: false
                            },
                            zoom : true
                        },
                        
                        dataLabels: {
                            enabled: false
                        },
                        stroke: {
                            curve: 'smooth'
                        },
                        colors: themeColors,
                        xaxis: {
                            labels : {
                                datetimeFormatter : {
                                    year : 'YYYY',
                                    month : 'MMMM',
                                    day: 'dd',
                                    hour : ''
                                }
                            },
                            type: 'datetime',
                            categories: categories,
                        },
                        tooltip: {
                            x: {
                            format: 'dd/MM/yy '
                            },
                        }
                    }
                }
            },

            ...mapGetters('ratings', ['statisticsRatings'])
        },
    }
</script>